<deletable-item-options (delete)="onDelete.emit()" [deleteLink]="deleteLink">
  <ng-content></ng-content>
  @if (showEdit) { @if (editLink) {
  <a [routerLink]="editLink">
    <span
      class="bi bi-pencil-fill d-inline d-sm-none"
      aria-hidden="true"
    ></span>
    <span class="d-none d-sm-block">edit</span>
  </a>
  } @if (!editLink) {
  <a (click)="onEdit.emit()">
    <span
      class="bi bi-pencil-fill d-inline d-sm-none"
      aria-hidden="true"
    ></span>
    <span class="d-none d-sm-block">edit</span>
  </a>
  } | }
</deletable-item-options>
